function resetTimeVideo(id: string) {
  const videoEle = document.getElementById(id);
  if (videoEle && videoEle instanceof HTMLVideoElement) {
    videoEle.currentTime = 0;
  }
}

function checkEndOfVideo(id: string, cb?: () => void) {
  const videoEle = document.getElementById(id);
  if (videoEle && videoEle instanceof HTMLVideoElement) {
    const remaining = videoEle.duration - videoEle.currentTime;
    if (remaining <= 0) {
      cb?.();
    }
  }
}

export { resetTimeVideo, checkEndOfVideo };
